import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  constructor() {}

  addHeaderParams(paramFields) {
    console.log('baseFilter.addHeaderParams()', paramFields)
    const defaultPagination = !('fetch' in paramFields);
    let params = new HttpParams()

    const paramsToUse = Object.entries<string>(paramFields)
    paramsToUse.map(field => {
      if ( field[1] !== '' ) {
        params = params.append(field[0], field[1])
      }
    })

    if (defaultPagination) {
      params = params.append('fetch', '10')
      params = params.append('offset', '0')
    }
    return params
  }
}
